import React from 'react';
import { Field } from 'react-final-form';
import DebouncingValidatingField from './debounceField';
import { ERRORSTYLE } from "../util/constants";

const validateBilling = async (value) => {
  if (!value) {
      return "Required";
  }
  let billing_contact = value;
  let billing_error = undefined;
  await fetch(`/api/person/${billing_contact}`)
      .then(res => {
          if (res.ok === false) {
            billing_error = "User not found";
          }
      })
      .catch((error) => {
        billing_error = "User not found";
      });
  return billing_error;
}

export function Billing(props) {
    const required = value => (value ? undefined : "Required");

    return (
    <div>
        <h3>Billing</h3>
        <table>
            <tbody>
                <tr key={"FDM"}>
                    <td>
                      <label>{"FDM"}</label>
                    </td>
                    <td>
                      <Field name="FDM" validate={required}>
                        {({ input, meta }) => (
                          <div>
                            <input {...input} type="text" />
                            {meta.error && meta.touched && <span style={ERRORSTYLE}>{meta.error}</span>}
                          </div>
                        )}
                      </Field>
                    </td>
                </tr>
                <tr key={"billing_contact"}>
                    <td>
                      <label>{"Billing Contact Username*"}</label>
                    </td>
                    <td>
                      <DebouncingValidatingField name="billing_contact" validate={validateBilling} debounce={1000}>
                        {({ input, meta }) => (
                          <div>
                            <input {...input}
                              type="text"
                              placeholder="(e.g. mst3k / mst3k@virginia.edu)"
                              onKeyPress={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                }
                              }} />
                              {meta.error && meta.touched && <span style={ERRORSTYLE}>{meta.error}</span>}
                          </div>
                        )}
                      </DebouncingValidatingField>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    );
}
